import { Typography } from '@mui/material'
import styles from './venderSettingTabs.module.scss'
import SwitchBtn from '../atoms/switch-btn/SwicthBtn'

const NOTIFICATION_LIST = [
	{
		title: 'Email notifications',
		description: 'Inquiries, bookings, payments',
	},
	{
		title: 'SMS notifications',
		description: 'Urgent inquiries, last-minute changes',
	},
	{
		title: 'In-app notifications',
		description: 'Task reminders, new Proposals, reviews',
	},
	{
		title: 'Push notifications',
		description: 'Mobile updates',
	},
	{
		title: 'Frequency settings',
		description: 'real-time, daily summary, weekly summary',
	},
	{
		title: 'Custom preferences per event or lead',
	},
]

export const NotificationSettings = () => {
	return (
		<div className={styles.tabPreviewWrp}>
			<div className={styles.notificationTab}>
				<div className={styles.tabPreviewTitle}>
					<Typography variant="h6">
						Notification Preferences
					</Typography>
				</div>
                {/* TODO: Uncomment when implemented */}
                <Typography>Coming soon!</Typography>
				{/* <ul className={styles.notificationList}>
					{NOTIFICATION_LIST.map((item, index) => (
						<li key={index}>
							<div className={styles.content}>
								<Typography variant="h6">
									{item.title}
								</Typography>
								<Typography variant="body1">
									{item.description}
								</Typography>
							</div>
							<div className={styles.switchBtn}>
								<SwitchBtn
									onClick={() => console.log('clicked')}
								/>
							</div>
						</li>
					))}
				</ul> */}
			</div>
		</div>
	)
}
